import { Heading, Stack, Text } from '../../ui';
import { formatElapsed } from '../../racing/format';
import type { Standing } from '../../racing/types';

/**
 * Renders the ranked standings of a time trial or heats final.
 *
 * @param props - The standings to render.
 * @returns The standings element, or an empty-state message when nothing has been scored.
 */
export function StandingsTable({ standings }: { readonly standings: readonly Standing[] }): React.JSX.Element {
  if (standings.length === 0) {
    return <Text muted>No times recorded yet.</Text>;
  }

  const showLaps = standings.some((standing) => standing.laps != null);

  return (
    <Stack gap="sm">
      <Heading level={3}>Standings</Heading>
      <table className="gm-standings">
        <thead>
          <tr>
            <th scope="col">#</th>
            <th scope="col">Contestant</th>
            {showLaps && <th scope="col">Laps</th>}
            <th scope="col">Best</th>
          </tr>
        </thead>
        <tbody>
          {standings.map((standing) => (
            <tr key={standing.contestantId}>
              <td>{standing.rank}</td>
              <td>{standing.displayName}</td>
              {showLaps && <td>{standing.laps ?? '—'}</td>}
              <td>{formatElapsed(standing.bestElapsedTimeMs)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </Stack>
  );
}
